module.exports = __webpack_public_path__ + "static/media/programming.0c5f8efc.svg";